import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslocoModule } from '@ngneat/transloco';


export interface UploadProgressData {
  total: number;
  progress: number;
  currentFileName?: string;

}

@Component({
  standalone: true,
  selector: 'app-upload-progress-dialog',
  styleUrls: ['upload-progress-dialog.component.scss'],
  template: `
    <h1 mat-dialog-title><strong>{{'modal.folder.loading' | transloco}}</strong></h1>
    <mat-dialog-content>
      <p>{{data.progress}} / {{data.total}} {{'modal.folder.nrOfFile' | transloco}}</p>
      <p *ngIf="data.currentFileName">
        {{ 'modal.folder.currentFile' | transloco }}: <strong>{{ data.currentFileName }}</strong>
      </p>
      <mat-progress-bar mode="determinate" [value]="(data.progress / data.total) * 100"></mat-progress-bar>
    </mat-dialog-content>
  `,
  imports: [MatDialogModule, MatProgressBarModule, TranslocoModule]
})
export class UploadProgressDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<UploadProgressDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UploadProgressData
  ) {}
}
